import { BASE_API } from '../../utils/constantes'
import { getToken } from '../Common/token'

export async function getHistorias(servicioId) {
    try {
        const url = `${BASE_API}/api-orion/servicio_historia/?servicio=${servicioId}`
        const params = {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        }
        const response = await fetch(url, params)
        if (response.status === 200) {
            const result = await response.json()
            return result
        }
        return false
    } catch (error) {
        console.error("Error al obtener historias:", error)
        return false
    }
}

export async function addHistoria(data) {
    try {
        const url = `${BASE_API}/api-orion/servicio_historia/`
        const params = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getToken()}`
            },
            body: JSON.stringify(data)
        }
        const response = await fetch(url, params)
        const result = await response.json()
        if (response.status === 201 || response.status === 200) {
            result["status"] = "success"
        } else {
            result["status"] = "error"
        }
        return result
    } catch (error) {
        console.error("Error al agregar historia:", error)
        return { status: "error" }
    }
}
